<template>
    <div class="container">
      <div class="card">
        <h1>Pedimos Desculpa</h1>
  
        <p>
          Informamos que o nosso site foi encerrado.  
          Para continuar a usar os nossos serviços, por favor utilize o nosso aplicativo
          disponível na Google Play Store.
        </p>
  
        <a
          class="btn"
          href="https://play.google.com/store/apps/details?id=com.firmasmane.proficionalmente&pcampaignid=web_share"
          target="_blank"
        >
          Baixar Aplicativo
        </a>
  
        <p class="contact">
          Caso tenha alguma dúvida, entre em contacto:
        </p>
  
        <a class="phone" href="tel:879107579">
          📞 879 107 579
        </a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "SiteClosed",
  };
  </script>
  
  <style scoped>
  .container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
    font-family: Arial, Helvetica, sans-serif;
  }
  
  .card {
    background: white;
    padding: 40px;
    max-width: 500px;
    text-align: center;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  }
  
  h1 {
    color: #e53935;
    margin-bottom: 20px;
  }
  
  p {
    color: #555;
    margin-bottom: 20px;
  }
  
  .btn {
    display: inline-block;
    background: #2e7d32;
    color: white;
    padding: 12px 25px;
    border-radius: 6px;
    text-decoration: none;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .btn:hover {
    background: #1b5e20;
  }
  
  .phone {
    display: block;
    font-size: 18px;
    font-weight: bold;
    color: #1976d2;
    text-decoration: none;
  }
  
  .contact {
    margin-top: 10px;
  }
  </style>